import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    PictureUpload,
    CheckBox,
    DataSelect,
    DatePicker,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffShopsEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formAccountBank, setFormAccountBank] = useState(null);
    const [formAccountBranchName, setFormAccountBranchName] = useState(null);
    const [formAccountNumber, setFormAccountNumber] = useState(null);
    const [formAccountIban, setFormAccountIban] = useState(null);
    const [formAccountOwner, setFormAccountOwner] = useState(null);
    const [formLogo, setFormLogo] = useState(null);
    const [formGatewayKeyNew, setFormGatewayKeyNew] = useState(null);
    const [formManagerName, setFormManagerName] = useState(null);
    const [formNationalId, setFormNationalId] = useState(null);
    const [formMobile, setFormMobile] = useState(null);
    const [formStateChangeSms, setFormStateChangeSms] = useState(false);
    const [formStateChangeOtherSms, setFormStateChangeOtherSms] = useState(false);
    const [formAllowNegativeAcountSend, setFormAllowNegativeAcountSend] = useState(false);
    const [formNegativeAcountLimit, setFormNegativeAcountLimit] = useState(null);
    const [formGatewayNeedToCollect, setFormGatewayNeedToCollect] = useState(false);
    const [formCollectDay, setFormCollectDay] = useState(null);
    const [formCancelMessage, setFormCancelMessage] = useState(false);
    const [formCancelLinkMessage, setFormCancelLinkMessage] = useState(false);
    const [formSmsPanelNumber, setFormSmsPanelNumber] = useState(null);
    const [formUnitId, setFormUnitId] = useState(null);
    const [formUnitIdOptions, setFormUnitIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-shops-edit/select-data/unit-id').then((response) => {
            setFormUnitIdOptions(response.data);
        });
    }, []);
    const [formNodeId, setFormNodeId] = useState(null);
    const [formNodeIdOptions, setFormNodeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-shops-edit/select-data/node-id').then((response) => {
            setFormNodeIdOptions(response.data);
        });
    }, []);
    const [formGatewayId, setFormGatewayId] = useState(null);
    const [formWebsite, setFormWebsite] = useState(null);
    const [formEmail, setFormEmail] = useState(null);
    const [formGatewayKeyV2, setFormGatewayKeyV2] = useState(null);
    const [formNationalIdSerial, setFormNationalIdSerial] = useState(null);
    const [formCityId, setFormCityId] = useState(null);
    const [formCityIdOptions, setFormCityIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-shops-edit/select-data/city-id').then((response) => {
            setFormCityIdOptions(response.data);
        });
    }, []);
    const [formAddress, setFormAddress] = useState(null);
    const [formPostCode, setFormPostCode] = useState(null);
    const [formPhone, setFormPhone] = useState(null);
    const [formTaroffConstShare, setFormTaroffConstShare] = useState(null);
    const [formTaroffSharePercent, setFormTaroffSharePercent] = useState(null);
    const [formServicePrice, setFormServicePrice] = useState(null);
    const [formPrePayPercent, setFormPrePayPercent] = useState(null);
    const [formPeikPrice, setFormPeikPrice] = useState(null);
    const [formPostConstPrice, setFormPostConstPrice] = useState(null);
    const [formStartDate, setFormStartDate] = useState(null);
    const [formEndDate, setFormEndDate] = useState(null);
    const [formBirthDate, setFormBirthDate] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-shops-edit/save-data', {
            id: allProps['id'],
            title: formTitle,
            account_bank: formAccountBank,
            account_branch_name: formAccountBranchName,
            account_number: formAccountNumber,
            account_iban: formAccountIban,
            account_owner: formAccountOwner,
            logo: formLogo,
            gateway_key_new: formGatewayKeyNew,
            manager_name: formManagerName,
            national_id: formNationalId,
            mobile: formMobile,
            state_change_sms: formStateChangeSms,
            state_change_other_sms: formStateChangeOtherSms,
            allow_negative_acount_send: formAllowNegativeAcountSend,
            negative_acount_limit: formNegativeAcountLimit,
            gateway_need_to_collect: formGatewayNeedToCollect,
            collect_day: formCollectDay,
            cancel_message: formCancelMessage,
            cancel_link_message: formCancelLinkMessage,
            sms_panel_number: formSmsPanelNumber,
            unit_id: formUnitId,
            node_id: formNodeId,
            gateway_id: formGatewayId,
            website: formWebsite,
            email: formEmail,
            gateway_key_v2: formGatewayKeyV2,
            national_id_serial: formNationalIdSerial,
            city_id: formCityId,
            address: formAddress,
            post_code: formPostCode,
            phone: formPhone,
            taroff_const_share: formTaroffConstShare,
            taroff_share_percent: formTaroffSharePercent,
            service_price: formServicePrice,
            pre_pay_percent: formPrePayPercent,
            peik_price: formPeikPrice,
            post_const_price: formPostConstPrice,
            start_date: formStartDate,
            end_date: formEndDate,
            birth_date: formBirthDate,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-shops-edit/form-data', {
            id: allProps['id'],
        }).then((response) => {
            setFormTitle(response.data.title);
            setFormAccountBank(response.data.account_bank);
            setFormAccountBranchName(response.data.account_branch_name);
            setFormAccountNumber(response.data.account_number);
            setFormAccountIban(response.data.account_iban);
            setFormAccountOwner(response.data.account_owner);
            setFormLogo(response.data.logo);
            setFormGatewayKeyNew(response.data.gateway_key_new);
            setFormManagerName(response.data.manager_name);
            setFormNationalId(response.data.national_id);
            setFormMobile(response.data.mobile);
            setFormStateChangeSms(response.data.state_change_sms);
            setFormStateChangeOtherSms(response.data.state_change_other_sms);
            setFormAllowNegativeAcountSend(response.data.allow_negative_acount_send);
            setFormNegativeAcountLimit(response.data.negative_acount_limit);
            setFormGatewayNeedToCollect(response.data.gateway_need_to_collect);
            setFormCollectDay(response.data.collect_day);
            setFormCancelMessage(response.data.cancel_message);
            setFormCancelLinkMessage(response.data.cancel_link_message);
            setFormSmsPanelNumber(response.data.sms_panel_number);
            setFormUnitId(response.data.unit_id);
            setFormNodeId(response.data.node_id);
            setFormGatewayId(response.data.gateway_id);
            setFormWebsite(response.data.website);
            setFormEmail(response.data.email);
            setFormGatewayKeyV2(response.data.gateway_key_v2);
            setFormNationalIdSerial(response.data.national_id_serial);
            setFormCityId(response.data.city_id);
            setFormAddress(response.data.address);
            setFormPostCode(response.data.post_code);
            setFormPhone(response.data.phone);
            setFormWebsite(response.data.website);
            setFormTaroffConstShare(response.data.taroff_const_share);
            setFormTaroffSharePercent(response.data.taroff_share_percent);
            setFormServicePrice(response.data.service_price);
            setFormPrePayPercent(response.data.pre_pay_percent);
            setFormPeikPrice(response.data.peik_price);
            setFormPostConstPrice(response.data.post_const_price);
            setFormStartDate(response.data.start_date);
            setFormEndDate(response.data.end_date);
            setFormBirthDate(response.data.birth_date);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش</Title>
                <Grid>
                    <GridColumn width={12}>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'عنوان'}
                                    value={formTitle}
                                    onChange={setFormTitle}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'بانک'}
                                    value={formAccountBank}
                                    onChange={setFormAccountBank}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'شعبه'}
                                    value={formAccountBranchName}
                                    onChange={setFormAccountBranchName}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'شماره حساب'}
                                    value={formAccountNumber}
                                    onChange={setFormAccountNumber}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'حساب Iban'}
                                    value={formAccountIban}
                                    onChange={setFormAccountIban}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'صاحب حساب'}
                                    value={formAccountOwner}
                                    onChange={setFormAccountOwner}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <PictureUpload
                                    label={'لوگو'}
                                    value={formLogo}
                                    onChange={setFormLogo}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'کلید گیت وی جدید'}
                                    value={formGatewayKeyNew}
                                    onChange={setFormGatewayKeyNew}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'نام مدیر'}
                                    value={formManagerName}
                                    onChange={setFormManagerName}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'کد ملی'}
                                    value={formNationalId}
                                    onChange={setFormNationalId}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'همراه'}
                                    value={formMobile}
                                    onChange={setFormMobile}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <CheckBox
                                    label={'پیامک تغییر وضعیت'}
                                    value={formStateChangeSms}
                                    onChange={setFormStateChangeSms}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <CheckBox
                                    label={'پیامک تغییر سایر وضعیت ها'}
                                    value={formStateChangeOtherSms}
                                    onChange={setFormStateChangeOtherSms}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <CheckBox
                                    label={'آماده ارسال در تراز منفی'}
                                    value={formAllowNegativeAcountSend}
                                    onChange={setFormAllowNegativeAcountSend}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'حد تراز منفی'}
                                    value={formNegativeAcountLimit}
                                    onChange={setFormNegativeAcountLimit}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <CheckBox
                                    label={'نیاز به جمع آوری'}
                                    value={formGatewayNeedToCollect}
                                    onChange={setFormGatewayNeedToCollect}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'روزهای جمع آوری'}
                                    value={formCollectDay}
                                    onChange={setFormCollectDay}
                                    placeholder="مثال: شنبه، دوشنبه، چهارشنبه"
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <CheckBox
                                    label={'پیامک کنسل'}
                                    value={formCancelMessage}
                                    onChange={setFormCancelMessage}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <CheckBox
                                    label={'پیامک لینک کنسل'}
                                    value={formCancelLinkMessage}
                                    onChange={setFormCancelLinkMessage}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'شماره پنل پیامکی'}
                                    value={formSmsPanelNumber}
                                    onChange={setFormSmsPanelNumber}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DataSelect
                                    label={'واحد'}
                                    options={formUnitIdOptions}
                                    value={formUnitId}
                                    onChange={setFormUnitId}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DataSelect
                                    label={'نود'}
                                    options={formNodeIdOptions}
                                    value={formNodeId}
                                    onChange={setFormNodeId}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'شناسه گیت وی (نسخه 3 سرویس)'}
                                    value={formGatewayId}
                                    onChange={setFormGatewayId}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'وبسایت'}
                                    value={formWebsite}
                                    onChange={setFormWebsite}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'ایمیل'}
                                    value={formEmail}
                                    onChange={setFormEmail}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'کلید گیت وی نسخه 2'}
                                    value={formGatewayKeyV2}
                                    onChange={setFormGatewayKeyV2}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'سریال کارت ملی'}
                                    value={formNationalIdSerial}
                                    onChange={setFormNationalIdSerial}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DataSelect
                                    label={'شناسه شهر'}
                                    options={formCityIdOptions}
                                    value={formCityId}
                                    onChange={setFormCityId}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'آدرس'}
                                    value={formAddress}
                                    onChange={setFormAddress}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'کد پستی'}
                                    value={formPostCode}
                                    onChange={setFormPostCode}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox label={'تلفن'} value={formPhone} onChange={setFormPhone} />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'وبسایت'}
                                    value={formWebsite}
                                    onChange={setFormWebsite}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'سهم ثابت تعارف'}
                                    value={formTaroffConstShare}
                                    onChange={setFormTaroffConstShare}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'سهم درصدی تعارف'}
                                    value={formTaroffSharePercent}
                                    onChange={setFormTaroffSharePercent}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'هزینه خدمات'}
                                    value={formServicePrice}
                                    onChange={setFormServicePrice}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'درصد پیش پرداخت'}
                                    value={formPrePayPercent}
                                    onChange={setFormPrePayPercent}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'هزینه پیک'}
                                    value={formPeikPrice}
                                    onChange={setFormPeikPrice}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <TextBox
                                    label={'هزینه ثابت پست'}
                                    value={formPostConstPrice}
                                    onChange={setFormPostConstPrice}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DatePicker
                                    label={'تاریخ شروع'}
                                    value={formStartDate}
                                    onChange={setFormStartDate}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DatePicker
                                    label={'تاریخ پایان'}
                                    value={formEndDate}
                                    onChange={setFormEndDate}
                                />
                            </GridColumn>
                        </Grid>
                        <Grid>
                            <GridColumn width={12}>
                                <DatePicker
                                    label={'تاریخ تولد'}
                                    value={formBirthDate}
                                    onChange={setFormBirthDate}
                                />
                            </GridColumn>
                        </Grid>
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
